/* eslint-disable import/prefer-default-export */
// NU_EXPERIMENT: expPdpButtonText
// https://urbnit.atlassian.net/browse/TYP-33468
export const EXP_PDP_BUTTON_TEXT_VARIANT_MAP = {
    variant_one: 'product__addToBox--label',
    variant_two: 'product__addToBox--labelVariantTwo',
    variant_three: 'product__addToBox--labelVariantThree',
};
